import { Directive } from '@angular/core';

@Directive({
  selector: 'ng-template[uiTableCell]',
})
export class TableCellDirective {
}
